/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserDisabledStatus } from './UserDisabledStatus';
import {
    UserDisabledStatusFromJSON,
    UserDisabledStatusFromJSONTyped,
    UserDisabledStatusToJSON,
} from './UserDisabledStatus';

/**
 * 
 * @export
 * @interface UserDisabledEvent
 */
export interface UserDisabledEvent {
    /**
     * The username of the admin that made the update
     * @type {string}
     * @memberof UserDisabledEvent
     */
    updatedBy?: string;
    /**
     * Timestamp when an admin disabled or enabled a user in milliseconds since the UNIX epoch
     * @type {number}
     * @memberof UserDisabledEvent
     */
    updateTime?: number;
    /**
     * Comment from the admin giving the reason the user was disabled
     * @type {string}
     * @memberof UserDisabledEvent
     */
    adminComment?: string;
    /**
     * 
     * @type {UserDisabledStatus}
     * @memberof UserDisabledEvent
     */
    status?: UserDisabledStatus;
}

/**
 * Check if a given object implements the UserDisabledEvent interface.
 */
export function instanceOfUserDisabledEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserDisabledEventFromJSON(json: any): UserDisabledEvent {
    return UserDisabledEventFromJSONTyped(json, false);
}

export function UserDisabledEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDisabledEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'updateTime': !exists(json, 'updateTime') ? undefined : json['updateTime'],
        'adminComment': !exists(json, 'adminComment') ? undefined : json['adminComment'],
        'status': !exists(json, 'status') ? undefined : UserDisabledStatusFromJSON(json['status']),
    };
}

export function UserDisabledEventToJSON(value?: UserDisabledEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updatedBy': value.updatedBy,
        'updateTime': value.updateTime,
        'adminComment': value.adminComment,
        'status': UserDisabledStatusToJSON(value.status),
    };
}

